"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../../../../shared/services");
var initialState = function () {
    return {
        showCartPopup: false,
        showProductAdded: false,
        addToCartError: null,
        cartMessage: null,
        mergingQuote: false,
        cartTotals: services_1.appSessionStorage.getItem('checkout-cart-totals', null),
        loadingCartTotals: !services_1.appSessionStorage.getItem('checkout-cart-totals-ready', false),
        shippingMethods: services_1.appSessionStorage.getItem('checkout-cart-estimate-shipping', []),
        headerTotals: services_1.appLocalStorage.getItem('checkout-cart-header-totals', null),
        defaultCarrierCode: null,
        defaultMethodCode: null,
        quoteItemActionTries: 0,
    };
};
var state = initialState();
var mutations = {
    SET_CART_TOTALS: function (state, data) {
        services_1.appSessionStorage.setItem('checkout-cart-totals', data);
        state.cartTotals = data;
    },
    SET_HEADER_TOTALS: function (state, data) {
        services_1.appLocalStorage.setItem('checkout-cart-header-totals', data);
        state.headerTotals = data;
    },
    SET_LOADING_TOTALS: function (state, data) {
        services_1.appSessionStorage.setItem('checkout-cart-totals-ready', !data);
        state.loadingCartTotals = data;
    },
    SET_SHIPPING_METHODS: function (state, shippingMethods) {
        services_1.appSessionStorage.setItem('checkout-cart-estimate-shipping', shippingMethods);
        state.shippingMethods = shippingMethods;
    },
    SHOW_CART_POPUP: function (state, payload) {
        state.showCartPopup = payload;
    },
    SHOW_PRODUCT_ADDED: function (state, payload) {
        state.showProductAdded = payload;
    },
    SET_CART_MESSAGE: function (state, message) {
        state.cartMessage = message;
    },
    SET_MERGING_QUOTE: function (state, payload) {
        state.mergingQuote = payload;
    },
    ADD_TO_CART_ERROR: function (state, payload) {
        state.addToCartError = payload;
    },
    SET_DEFAULT_CARRIER_DATA: function (state, data) {
        state.defaultMethodCode = data['methodCode'];
        state.defaultCarrierCode = data['carrierCode'];
    },
};
var actions = {
    collectDefaultShippingMethods: function (_a) {
        var rootState = _a.rootState, rootGetters = _a.rootGetters, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$mageClient.post(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/estimate-shipping-methods", {
                                address: rootState['CheckoutCheckout']['shippingAddress']
                            })];
                    case 1:
                        data = (_b.sent()).data;
                        if (data.length > 0) {
                            commit('SET_DEFAULT_CARRIER_DATA', {
                                methodCode: data[0]['method_code'],
                                carrierCode: data[0]['carrier_code'],
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    createQuote: function (_a) {
        var rootGetters = _a.rootGetters, commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.$mageClient.post("" + rootGetters['CheckoutGlobal/getApiPath'])];
                    case 1:
                        data = (_b.sent()).data;
                        commit('CheckoutGlobal/SET_QUOTE_MASK', data, { root: true });
                        return [4 /*yield*/, dispatch('fetchQuote')];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    fetchQuote: function (_a) {
        var rootState = _a.rootState, rootGetters = _a.rootGetters, commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 7]);
                        return [4 /*yield*/, this.$mageClient.get("" + rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'])];
                    case 1:
                        data = (_b.sent()).data;
                        if (!!data['is_active']) return [3 /*break*/, 3];
                        return [4 /*yield*/, dispatch('createQuote')];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3: return [4 /*yield*/, commit('CheckoutGlobal/SET_QUOTE', data, { root: true })];
                    case 4:
                        _b.sent();
                        return [2 /*return*/, rootState['CheckoutGlobal']['quote']];
                    case 5:
                        e_3 = _b.sent();
                        return [4 /*yield*/, dispatch('createQuote')];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    addProductToQuote: function (_a, payload) {
        var rootState = _a.rootState, rootGetters = _a.rootGetters, commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, commit('SET_LOADING_TOTALS', true)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, commit('ADD_TO_CART_ERROR', false)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, dispatch('CheckoutGlobal/getActiveQuote', null, { root: true })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 14]);
                        return [4 /*yield*/, this.$mageClient.post(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/bulkItems", {
                                cartItems: [
                                    {
                                        sku: payload.sku,
                                        qty: payload.qty,
                                        quote_id: "" + rootGetters['CheckoutGlobal/getQuoteIdentifier'],
                                        product_option: payload.product_option
                                    },
                                ],
                            })];
                    case 5:
                        data = (_b.sent()).data;
                        state.quoteItemActionTries = 0;
                        commit('SET_CART_TOTALS', data);
                        commit('SET_HEADER_TOTALS', data);
                        commit('SHOW_CART_POPUP', true);
                        commit('SHOW_PRODUCT_ADDED', true);
                        commit('CheckoutGlobal/SET_LAST_ADDED_ITEM', data.extension_attributes.last_added_item, { root: true });
                        commit('CheckoutGlobal/SET_QUOTE_ITEMS', data.items, { root: true });
                        commit('CheckoutGlobal/SET_QUOTE_ITEM_COUNT', data.items_qty, { root: true });
                        return [3 /*break*/, 14];
                    case 6:
                        err_1 = _b.sent();
                        if (!err_1.hasOwnProperty('response')) {
                            commit('ADD_TO_CART_ERROR', true);
                            console.log(err_1);
                            return [2 /*return*/];
                        }
                        if (!(err_1.response.status === 404)) return [3 /*break*/, 10];
                        if (!payload.hasOwnProperty('tries')) {
                            payload = __assign({ tries: 0 }, payload);
                        }
                        if (payload.tries >= 3) {
                            commit('ADD_TO_CART_ERROR', true);
                        }
                        if (!(payload.hasOwnProperty('tries') && payload.tries < 3)) return [3 /*break*/, 9];
                        payload.tries++;
                        return [4 /*yield*/, dispatch('CheckoutGlobal/createNewQuote', null, { root: true })];
                    case 7:
                        _b.sent();
                        return [4 /*yield*/, dispatch('addProductToQuote', payload)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3 /*break*/, 13];
                    case 10:
                        if (!(err_1.response.status === 400)) return [3 /*break*/, 13];
                        if (state.quoteItemActionTries >= 3) {
                            if (err_1.response.data.hasOwnProperty('message')) {
                                commit('SET_CART_MESSAGE', err_1.response.data.message);
                            }
                            commit('ADD_TO_CART_ERROR', true);
                        }
                        if (!(state.quoteItemActionTries < 3)) return [3 /*break*/, 13];
                        state.quoteItemActionTries++;
                        return [4 /*yield*/, dispatch('fetchQuote')];
                    case 11:
                        _b.sent();
                        return [4 /*yield*/, dispatch('addProductToQuote', payload)];
                    case 12:
                        _b.sent();
                        _b.label = 13;
                    case 13: return [3 /*break*/, 14];
                    case 14: return [2 /*return*/];
                }
            });
        });
    },
    mergeQuote: function (_a) {
        var rootState = _a.rootState, dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _oldItemCount, _mergeUrl, e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('SET_LOADING_TOTALS', true);
                        commit('SET_MERGING_QUOTE', true);
                        _oldItemCount = rootState['CheckoutGlobal']['quoteItemCount'];
                        _mergeUrl = "/rest/" + rootState['CheckoutGlobal']['storeCode'] + "/V1/guest-carts/" + rootState['CheckoutGlobal']['quoteMask'];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 6, 12]);
                        return [4 /*yield*/, dispatch('fetchQuote')];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.$mageClient.put(_mergeUrl, {
                                customerId: "" + rootState['CheckoutGlobal']['customer']['entity_id'],
                                storeId: "" + rootState['CheckoutGlobal']['customer']['store_id']
                            })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 12];
                    case 4:
                        e_4 = _b.sent();
                        return [4 /*yield*/, this.$mageClient.put(_mergeUrl, {
                                customerId: "" + rootState['CheckoutGlobal']['customer']['entity_id'],
                                storeId: "" + rootState['CheckoutGlobal']['customer']['store_id']
                            })];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 12];
                    case 6: return [4 /*yield*/, dispatch('fetchQuote')];
                    case 7:
                        _b.sent();
                        return [4 /*yield*/, dispatch('fetchCartTotals', 'cart')];
                    case 8:
                        _b.sent();
                        if (!(_oldItemCount !== rootState['CheckoutGlobal']['quoteItemCount'])) return [3 /*break*/, 10];
                        return [4 /*yield*/, commit('SET_MERGING_QUOTE_MESSAGE', true)];
                    case 9:
                        _b.sent();
                        _b.label = 10;
                    case 10: return [4 /*yield*/, commit('SET_MERGING_QUOTE', false)];
                    case 11:
                        _b.sent();
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    },
    updateQuoteItemQty: function (_a, cartItem) {
        var dispatch = _a.dispatch, rootGetters = _a.rootGetters, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('SET_LOADING_TOTALS', true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 7]);
                        return [4 /*yield*/, this.$mageClient.put(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/items/" + cartItem['item_id'], {
                                cartItem: {
                                    sku: cartItem.sku,
                                    qty: cartItem.qty,
                                    quote_id: "" + rootGetters['CheckoutGlobal/getQuoteIdentifier']
                                }
                            })];
                    case 2:
                        _b.sent();
                        state.quoteItemActionTries = 0;
                        return [3 /*break*/, 7];
                    case 3:
                        err_2 = _b.sent();
                        if (!(err_2.response.status === 404 || err_2.response.status === 400)) return [3 /*break*/, 6];
                        if (state.quoteItemActionTries >= 3) {
                            commit('ADD_TO_CART_ERROR', true);
                        }
                        if (!(state.quoteItemActionTries < 3)) return [3 /*break*/, 6];
                        state.quoteItemActionTries++;
                        return [4 /*yield*/, dispatch('fetchQuote')];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, dispatch('updateQuoteItemQty', cartItem)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    deleteQuoteItem: function (_a, cartItemId) {
        var rootGetters = _a.rootGetters, dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('SET_LOADING_TOTALS', true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 7]);
                        return [4 /*yield*/, this.$mageClient.delete(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/items/" + cartItemId)];
                    case 2:
                        _b.sent();
                        state.quoteItemActionTries = 0;
                        return [3 /*break*/, 7];
                    case 3:
                        err_3 = _b.sent();
                        if (!(err_3.response.status === 404 || err_3.response.status === 400)) return [3 /*break*/, 6];
                        if (state.quoteItemActionTries >= 3) {
                            commit('ADD_TO_CART_ERROR', true);
                        }
                        if (!(state.quoteItemActionTries < 3)) return [3 /*break*/, 6];
                        state.quoteItemActionTries++;
                        return [4 /*yield*/, dispatch('fetchQuote')];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, dispatch('deleteQuoteItem', cartItemId)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 7];
                    case 7: return [4 /*yield*/, dispatch('fetchCartTotals', 'cart')];
                    case 8: return [2 /*return*/, _b.sent()];
                }
            });
        });
    },
    fetchCartTotals: function (_a, step) {
        var state = _a.state, rootGetters = _a.rootGetters, commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _billingAddress, _shippingAddress, data, outOfStock, err_4;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        commit('SET_LOADING_TOTALS', true);
                        _b = rootGetters['CheckoutCheckout/getAddressData'], _billingAddress = _b[0], _shippingAddress = _b[1];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, this.$mageClient.post(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/totals-information", {
                                addressInformation: {
                                    address: _shippingAddress.hasOwnProperty('country_id') || _shippingAddress.hasOwnProperty('countryId')
                                        ? _shippingAddress
                                        : {
                                            prefix: "",
                                            firstname: "",
                                            middlename: "",
                                            lastname: "",
                                            postcode: "",
                                            street: ["", "", ""],
                                            city: "",
                                            telephone: "",
                                            company: "",
                                            country_id: "NL"
                                        },
                                    shipping_method_code: state.defaultMethodCode,
                                    shipping_carrier_code: state.defaultCarrierCode,
                                }
                            })];
                    case 2:
                        data = (_c.sent()).data;
                        commit('SET_CART_TOTALS', data);
                        commit('SET_HEADER_TOTALS', data);
                        commit('CheckoutGlobal/SET_QUOTE_ITEMS', data.items, { root: true });
                        commit('CheckoutGlobal/SET_QUOTE_ITEM_COUNT', data.items_qty, { root: true });
                        if (!(step === 'checkout' || step === 'payment')) return [3 /*break*/, 4];
                        return [4 /*yield*/, dispatch('CheckoutPayment/collectPaymentMethods', null, { root: true })];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        if (step !== 'cart') {
                            outOfStock = data['items'].filter(function (item) {
                                return !item['extension_attributes']['product_stock'] || item['extension_attributes']['product_stock'] < item['qty'];
                            });
                            if (outOfStock.length) {
                                window.location.replace('/checkout/cart');
                            }
                        }
                        return [2 /*return*/, data];
                    case 5:
                        err_4 = _c.sent();
                        if (err_4.hasOwnProperty('response')) {
                            window.location.replace('/checkout/cart#clear');
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        commit('SET_LOADING_TOTALS', false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    showCartPopup: function (_a, status) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        commit('SHOW_CART_POPUP', status);
        if (status && null === state.headerTotals) {
            try {
                dispatch('fetchCartTotals');
            }
            catch (e) {
                console.log(e);
            }
        }
    },
    showProductAdded: function (_a, payload) {
        var commit = _a.commit;
        commit('SHOW_PRODUCT_ADDED', payload);
    },
};
var getters = {
    cartTotals: function (state) { return state.cartTotals; },
    headerTotals: function (state) { return state.headerTotals; },
    loadingCartTotals: function (state) { return state.loadingCartTotals; },
    showCartPopup: function (state) { return state.showCartPopup; },
    showProductAdded: function (state) { return state.showProductAdded; },
};
var CheckoutCart = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
exports.default = CheckoutCart;
